import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-system-message-card',
  templateUrl: './system-message-card.component.html',
  styleUrls: ['./system-message-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SystemMessageCardComponent {
  // Signal-based input
  rawSystemMessage = input.required<string>({ alias: 'systemMessage' });

  // Computed signal for translated system message
  systemMessage = computed(() => {
    const message = this.rawSystemMessage();
    return this.translateSystemMessage(message);
  });

  systemMessagesObj: any = {
    unableToSentMsg: 'Unable to send previous message to user ',
    SMSEnabledMsg: 'SMS is enabled and will use ',
    unableToSentAttachment: 'Unable to send previous attachment to user ',
    Provider: 'Provider'
  };

  constructor(private translate: TranslateService) {}

  /**
   * Translate system message based on current language
   */
  private translateSystemMessage(message: string): string {
    if (!this.translate.currentLang || !message) {
      return message;
    }

    const translationKey = this.isStringInObject(this.systemMessagesObj, message);

    if (translationKey) {
      let translatedString = this.translate.instant(`systemMessages.${translationKey}`);
      if (translatedString !== `systemMessages.${translationKey}`) {
        let splittedString = message.split(this.systemMessagesObj[translationKey]);
        let valueInString = '';
        if (splittedString[0]) {
          valueInString = splittedString[0];
        } else {
          valueInString = splittedString[1];
        }

        if (translationKey == this.systemMessagesObj.Provider) {
          return message.replace(this.systemMessagesObj.Provider, translatedString);
        } else if (translationKey == 'SMSEnabledMsg') {
          let value = message
            .replace('SMS is enabled and will use ', '')
            .replace(' to send/receive text messages.', '');
          return translatedString.replace('{0}', value);
        } else {
          return translatedString.replace('{0}', valueInString);
        }
      }
    }

    return message;
  }

  /**
   * Method isStringInObject filter out the matched string from translations
   * @param obj complete set of objects
   * @param targetString string to match
   * @returns
   */
  isStringInObject(obj: any, targetString: string) {
    for (const key in obj) {
      const val = obj[key];
      if (obj.hasOwnProperty(key) && typeof targetString === 'string' && targetString.includes(val)) {
        return key;
      }
    }
    return false;
  }
}
